import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=ceb38b1e&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=ceb38b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb38b1e",
  null
  
)

export default component.exports